import { useParams } from "react-router";
import { IconExclamationCircle } from "@tabler/icons-react";
import AppHeader from "@/lib/components/AppHeader";
import LoadingSpinner from "@/lib/components/LoadingSpinner";
import NotificationsDropdown from "@/lib/components/NotificationsDropdown";
import { useSidebar } from "@/lib/components/Sidebar";
import { useSelfQuery } from "@/lib/queries/user-queries";
import { useHomeQuery } from "@/lib/queries/home-queries";
import VideoSearchBar from "../Videos/VideoSearchBar";
import ActionCards from "./ActionCards";
import RecentSection from "./RecentSection";
import LearnSection from "./LearnSection";
import { useOpenedTutorialIds } from "./tutorial-hooks";

function getGreeting(hour: number) {
  if (hour >= 5 && hour < 12) {
    return "Good morning";
  }
  if (hour >= 12 && hour < 17) {
    return "Good afternoon";
  }
  return "Good evening";
}

export default function HomePage() {
  const { teamExternalId } = useParams();
  const { isMobile } = useSidebar();
  const { data: self, isError: isSelfError } = useSelfQuery();
  const { data: home, isError: isHomeError } = useHomeQuery(teamExternalId!);
  const openedTutorialIds = useOpenedTutorialIds();

  const greeting = getGreeting(new Date().getHours());

  return (
    <div className="flex flex-1 flex-col overflow-y-auto">
      <AppHeader actionChildren={!isMobile && <NotificationsDropdown />}>
        <VideoSearchBar />
      </AppHeader>
      {home && self && openedTutorialIds ? (
        <div className="px-4 pb-10 md:px-6">
          <div className="mt-12 mb-8">
            <h1 className="text-2xl font-bold md:text-[28px] md:leading-9">
              {self.firstName ? `${greeting}, ${self.firstName}` : greeting} 👋
            </h1>
            <p className="text-lg font-medium text-text-secondary md:text-xl">
              {home.hasCreatedContent
                ? "Ready for your next listing video?"
                : "Let's make your first listing video"}
            </p>
          </div>
          <ActionCards />
          <RecentSection recent={home.recent} />
          <LearnSection
            hasCreatedContent={home.hasCreatedContent}
            openedTutorialIds={openedTutorialIds}
          />
        </div>
      ) : isHomeError || isSelfError ? (
        <div
          role="alert"
          className="flex flex-1 items-center justify-center gap-2 py-12"
        >
          <IconExclamationCircle
            size={24}
            className="shrink-0 text-error"
            aria-hidden="true"
          />
          <p className="font-medium">Failed to load home page</p>
        </div>
      ) : (
        <div className="flex flex-1 items-center justify-center">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
}
